import { cn } from '@/lib/ui/style-helpers'

import { lemaAiAccentVariants } from '@/pages/control/risk-questionnaire-thread-card/variants'

import SparklesFilledIcon from '@/assets/sparkles-filled.svg'

type LemaAiIconProps = {
  isHighlighted: boolean
}

export const LemaAiIcon = ({ isHighlighted }: LemaAiIconProps) => (
  <SparklesFilledIcon
    className={cn('size-4 shrink-0', lemaAiAccentVariants({ isHighlighted }))}
    aria-hidden
  />
)
